var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componente",style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left })},[_c('div',{staticClass:"full",on:{"mousedown":function($event){return _vm.pulsado(true)},"mouseup":function($event){return _vm.pulsado(false)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icono))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }